import { useScrollIntoView } from '@/hooks/useScrollIntoView';

export const NetworkErrorMessage = ({ message }: { message: string }) => {
  const ref = useScrollIntoView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      role="alert"
      className="bg-red-50 border border-red-200 rounded-md text-red-600 text-xl px-4 py-3 my-4 mx-20"
    >
      {message}
    </div>
  );
};
